import React, { useEffect, useState } from "react";

import {
  Alert,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import Loader from "../../../components/loader/Loader";
import { hideConfirmModal } from "../../../redux/counterSlice";
import DriverOrderItem from "./DriverOrderItem";

function DriverPanel() {
  const dispatch = useDispatch();

  const [loader, setLoader] = useState(true);
  const [orderList, setOrderList] = useState([]);
  const [driver, setDriver] = useState(0);
  const [driverList, setDriverList] = useState();

  const loadInitialData = () => {
    const url = "/getAllDriverList";
    setLoader(true);
    axios
      .get(url)
      .then(function (response) {
        setDriverList(response?.data?.data);
      })
      .catch(function (err) {
        toast.error(err?.message);
      })
      .finally(() => {
        setLoader(false);
        dispatch(hideConfirmModal({ msg: "" }));
      });
  };

  const listAllDriverOrders = () => {
    if (driver > 0) {
      setLoader(true);
      axios
        .post("/getAllOrdersForDriver", {
          driverId: driver,
          operation: "GET_DRIVER_ORDERS_OPERATION",
        })
        .then(function (response) {
          setOrderList(response?.data?.data);
        })
        .catch(function (err) {
          toast.error(err?.message);
        })
        .finally(() => {
          setLoader(false);
          dispatch(hideConfirmModal({ msg: "" }));
        });
    }
  };

  const handleShopChange = (value) => {
    setDriver(value);
    sessionStorage.setItem("selected_driver", value);
  };
  useEffect(() => {
    loadInitialData();
  }, []);

  useEffect(() => {
    listAllDriverOrders();
  }, [driver]);
  useEffect(() => {
    const selectedLocation = sessionStorage.getItem("selected_driver");
    setDriver(selectedLocation);
  }, [orderList]);

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <Typography
            variant="h5"
            className="text-dark"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "1.1rem", sm: "1.3rem", md: "1.5rem" },
              px: { xs: 1, sm: 0 },
            }}
          >
            Driver Panel
          </Typography>

          <Paper
            elevation={1}
            sx={{
              p: { xs: 1.5, sm: 2.5, md: 3 },
              margin: "auto",
              marginTop: "15px",
              flexGrow: 1,
            }}
          >
            <Grid container spacing={{ xs: 2, sm: 3 }}>
              {/* Driver selector: full width on mobile, right-aligned narrower box on larger screens */}
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                sx={{
                  ml: { sm: "auto" }, // pushes it right on tablet/desktop, stacks full-width on mobile
                }}
              >
                <FormControl fullWidth margin="none">
                  <InputLabel id="status_dropdown_label">Driver</InputLabel>
                  <Select
                    labelId="status_dropdown_label"
                    id="status_dropdown_select"
                    value={driver}
                    label="Driver"
                    onChange={(e) => handleShopChange(e?.target?.value)}
                  >
                    <MenuItem value={0}>--Select Driver--</MenuItem>
                    {driverList?.map((item) => (
                      <MenuItem key={item?.driver_id} value={item?.driver_id}>
                        {`${item?.driver_name} -  (${item?.driver_mobile})`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Order cards: 1 per row on phones, 2 on tablets, 3 on desktop */}
              <Grid item xs={12}>
                <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }}>
                  {orderList?.length > 0 ? (
                    orderList?.map((driverOrder, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={driverOrder?.id ?? index}
                      >
                        <DriverOrderItem driver={driverOrder} />
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12}>
                      <Stack sx={{ width: "100%", mt: { xs: 2, sm: 3 } }} spacing={2}>
                        <Alert severity="warning">
                          <h6 style={{ margin: 0 }}>No Data Found..</h6>
                        </Alert>
                      </Stack>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </>
      )}
    </>
  );
}

export default DriverPanel;